import styled from "styled-components";

export const ContentBox = styled.div`
    display: block;
    align-content: center;
    margin: 2rem;
    margin-left: auto;
    margin-right: auto;
    background-color: #ebebeb;
    padding: 2rem;
    border-radius: 12px;
    max-width: 800px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
`